import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CarouseEntityParams {
  name: string;
  scrollX?: number;
  scrollY?: number;
  top?: number;
  left?: number;
  belowFold?: boolean;
  productLinePriceBucket?: number;
  priceSegmentationBuckets?: number[];
}
export class CarouselEntity extends BaseEntityClass {
  name: string;
  scrollX?: number;
  scrollY?: number;
  top?: number;
  left?: number;
  belowFold?: boolean;
  productLinePriceBucket?: number = null;
  priceSegmentationBuckets?: number[] = null;
  constructor(params: CarouseEntityParams) {
    super();
    this.type = "carousel";
    this.entity_version = 3;
    this.name = params.name;
    this.scrollX = params.scrollX;
    this.scrollY = params.scrollY;
    this.top = params.top;
    this.left = params.left;
    this.belowFold = params.belowFold;
    this.productLinePriceBucket = params.productLinePriceBucket;
    this.priceSegmentationBuckets = params.priceSegmentationBuckets;
  }
}
